import { useUser } from "@clerk/clerk-react";

const Dashboard = () => {
  const { user } = useUser();

  return (
    <div className="flex min-h-screen">
      <main className="flex-1 px-6 py-12">
        <section className="flex flex-col items-center justify-center text-center mb-16">
          <h1 className="text-4xl font-bold">
            Welcome to Equity App {user?.fullName}
          </h1>
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
